let year = new Date().getFullYear();
export const privacypolicy = {
  english: {
    title: 'Privacy Policy',
    sggsProject: 'INTRODUCTION',
    subTagLine: '',
    theVision: '',
    paragraph1:
      'The Guru Granth Sahib Project (“TGGSP” or "Company" or "we" or “us”) respects your privacy and is committed to protecting it through its compliance with this policy.',
    paragraph2:
      'This policy describes the types of information we may collect from you or that you may provide when you visit the website',
    link2_1:
    'https://gurugranthsahib.io',  

    paragraph2_1:
    '(the "Website") and our practices for collecting, using, maintaining, protecting, and disclosing that information.',

    paragraph3:
      'This policy applies to the information we collect:',
    paragraph3_1:
    '- On the Website.',
    paragraph3_2:
    '- In e-mail, text, and other electronic messages between you and the Website.',
    
    paragraph4:
    'It does not apply to information collected by:',
    paragraph4_1:
    '- Us offline or through any other means, including on any other website operated by the Company or any third party; or',
    paragraph4_2:
    '- Any third party (including our affiliates and subsidiaries), including through any application or content (including advertising) that may link to or be accessible from the Website',
    
    paragraph5:
    'Please understand our policies and practices regarding your information. If you disagree with our policies and practices, please choose not to use the Website. By accessing or using the Website, you agree to this Privacy Policy. This Policy may change from time to time. Please check the Policy periodically for updates.',

    paragraph6:
    'CHILDREN UNDER THE AGE OF 13',

    paragraph7:
    'The Website is not intended for children under 13 years of age. No one under 13 may provide any information to the Website. We do not knowingly collect personal information from children under 13. If we learn we have collected or received personal information from a child under 13 without verification of parental consent, we will delete that information. If you believe we have any information from or about a child under 13, please contact us at 470 Schooleys Mt Road, Ste 614 Hackettstown, NJ 07840 USA, or at ',
    mail_link:
    'community@sikhri.org',
    paragraph8:
    'INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT',

    paragraph9:
    'We collect several types of information from and about users of the Website, including information:',
    paragraph9_1:
    '- By which you may be personally identified, such as name, postal address, e-mail address, or telephone number ("personal information");',
    paragraph9_2:
    '- That is about you but individually does not identify you; and/or',
    paragraph9_3:
    '- About your internet connection, the equipment you use to access our Website, and usage details.',

    paragraph10:
    'We collect this information:',
    paragraph10_1:
    '- Directly from you when you provide it to us.',
    paragraph10_2:
    '- Automatically as you navigate through the site. Information collected automatically may include usage details, IP addresses, and information collected through cookies.',

    paragraph11:
    'INFORMATION YOU PROVIDE TO US',

    paragraph11_1:
    'The information we collect on or through the Website may include:',
    paragraph11_2:
    '- Information that you provide by filling in forms on our Website. This includes information provided when registering to use the Website, posting material, or requesting further services.',
    paragraph11_3:
    '- You must enter your credit card information when donating by credit card. This information WILL NOT be stored on the TGGSP site. Our payment processing partners, CanadaHelps, PayPal, Stripe, Shopify & eCheck, provide solutions to prevent credit card and banking data from being compromised. All transactions through TGGSP use Transport Layer Security (TLS) to keep information secure and protect against loss or misuse.',
    paragraph11_4:
    '- We may also ask you for information when you report a problem with the Website. If you donated anonymously, your name and e-mail address will not be revealed to other organizations/projects. TGGSP will keep a record of donations but won’t reveal this information.',
    paragraph11_5:
    '- Records and copies of your correspondence (including e-mail addresses) if you contact us.',
    paragraph11_6:
    '- Details of transactions you carry out through the Website and the fulfillment of your orders.',

    paragraph12:
    'You also may provide information to be published or displayed (hereinafter, "posted") on public areas of the Website or transmitted to other users of the Website or third parties (collectively, "User Contributions"). Your User Contributions are posted on and transmitted to others at your own risk. Although you may set certain privacy settings for such information by logging into your account profile, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of other website users with whom you may choose to share your User Contributions. Therefore, we cannot and do not guarantee that unauthorized persons will not view your User Contributions.',

    paragraph13:
    'USAGE DETAILS, IP ADDRESSES',
    paragraph13_1:
    'As you navigate through and interact with the Website, we may automatically collect certain information about your equipment, browsing actions, and patterns, including:',
    paragraph13_2:
    '- Details of your visits to the Website, including traffic data, location data, and other communication data and the resources you access and use on the Website.',
    paragraph13_3:
    '- Information about your computer and Internet connection, including your IP address, operating system, and browser type.',

    paragraph14:
    'The information we collect automatically is statistical data and does not identify any individual. It helps us to improve the Website and to deliver a better and more personalized service by enabling us to:',
    paragraph14_1:
    '- Estimate our audience size and usage patterns.',
    paragraph14_2:
    '- Store information about your preferences, allowing us to customize the Website according to your interests.',
    paragraph14_3:
    '- Speed up your searches.',
    paragraph14_4:
    '- Recognize you when you return to the Website.',

    paragraph15:
    'The technologies we use for this automatic data collection may include:',
    paragraph15_1:
    '- Cookies (or browser cookies). A cookie is a small file placed on your computer\'s hard drive. You may refuse to accept browser Cookies by activating the appropriate setting on your browser. However, if you select this setting, you may be unable to access certain parts of our Website. Unless you have adjusted your browser setting to refuse cookies, our system will issue cookies when you direct your browser to our Website.',
    paragraph15_2:
    '- Flash Cookies. Certain website features may use locally stored objects (or Flash cookies) to collect and store information about your preferences and navigation to, from, and on the Website. Flash cookies are not managed by the same browser settings used for browser cookies.',


    paragraph16:
    'THIRD PARTIES AND USE OF COOKIES',
    paragraph17:
    'TGGSP respects your privacy and will never sell, trade, or rent your personal information to outside 3rd parties without consent. Your donation information will be available to the projects and organizations you donate to.',
    paragraph18:
    'Our site uses cookies to keep track of your session ID. We may use cookies to deliver content specific to your interests. We may also track the pages you request, the newsletters you subscribe to, and the advertisements you click on.',
    paragraph19:
    'Third parties may serve some content and/or advertisements on the Website. These third parties may use cookies to collect information about our users. This may include information about user\'s behavior on this and other websites to serve them interested-based (behavioral) advertising. We do not control these third parties tracking technologies or how they may be used. If you have any questions, you should contact the responsible advertiser directly.',

    paragraph20:
    '‍HOW WE USE YOUR INFORMATION',
    paragraph21:
    'We use information that we collect about you or that you provide to us, including any personal information:',
    paragraph21_1:
    '- To present the Website and its contents to you.',
    paragraph21_2:
    '- To provide you with information, products, or services you request from us.',
    paragraph21_3:
    '- To fulfill any other purpose for which you provide it.',
    paragraph21_4:
    '- To carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection.',
    paragraph21_5:
    '- To notify you about changes to the Website or any products or services we offer or provide through it.',
    paragraph21_6:
    '- In any other way, we may describe when you provide the information.',
    paragraph21_7:
    '- For any other purpose with your consent.',
   
    paragraph22:
    'DISCLOSURE OF YOUR INFORMATION',
    paragraph23:
    'We may disclose aggregated information about our users and information that does not identify any individual without restriction.',
    paragraph24:
    'We may disclose personal information we collect or you provide as described in this Privacy Policy:',
    paragraph24_1:
    '- To our subsidiaries and affiliates.',
    paragraph24_2:
    '- To contractors, service providers, and other third parties we use to support our business, and those bound by contractual obligations to keep personal information confidential and use it only for the purposes we disclose it to them.',
    paragraph24_3:
    '- To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of TGGSP\'s assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by TGGSP about the Website users is among the assets transferred.',
    paragraph24_4:
    '- To fulfill the purpose for which you provide it.',
    paragraph24_5:
    '- For any other purpose disclosed by us when you provide the information.',
    paragraph24_6:
    '- With your consent.',
   
    paragraph25:
    'We may also disclose your personal information:',
    paragraph25_1:
    '- To comply with any court order, law, or legal process, including responding to any government or regulatory request.',
    paragraph25_2:
    '- If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of TGGSP, our customers, or others.',
   
    paragraph26:
    'CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION',
    paragraph27:
    'We strive to provide you with choices regarding the personal information you provide us. We have created mechanisms to provide you with the following control over your information:',
    paragraph27_1:
    '- Tracking Technologies and Advertising. You can set your browser to refuse all or some browser cookies or to alert you when cookies are being sent. To learn how to manage your Flash cookie settings, visit Adobe\'s Flash player settings page. If you disable or refuse cookies, please note that some parts of this site may be inaccessible or malfunctioning.',
    paragraph28:
    'We do not control third parties collection or use of your information to serve interest-based advertising. However, these third parties may provide ways to refrain from having your information collected or used this way. You can opt out of receiving targeted ads from members of the Network Advertising Initiative ("NAI") on the NAI\'s Website.',
    
    paragraph29:
    'ACCESSING AND CORRECTING YOUR INFORMATION',
    paragraph30:
    'You may also send us an e-mail at', 

    paragraph30_1: 
    'to request access to, correct, or delete any personal information you provided. We cannot delete your personal information. We may not accommodate a request to change information if we believe the change would violate any law or legal requirement or cause the information to be incorrect.',
    paragraph31:
    'Suppose you delete your User Contributions from the Website. In that case, copies of your User Contributions may remain viewable in cached and archived pages or have been copied or stored by other Website users.',
    paragraph32:
    'YOUR CALIFORNIA PRIVACY RIGHTS',
    paragraph33:
    'California Civil Code Section § 1798.83 permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an e-mail to', 
    paragraphAt: 'or write us at:',
    paragraph33_1: 
    '470 Schooleys Mt Road, Ste 614',
    paragraph33_2:
    'Hackettstown, NJ 07840 USA',

    paragraph34:
    'DATA SECURITY',

    paragraph35:
    'We have implemented measures to secure your personal information from accidental loss and unauthorized access, use, alteration, and disclosure. All information you provide is stored on our secure servers behind firewalls. Any payment transactions will be encrypted. The safety and security of your information also depends on you. ',
    
    paragraph36:
    'Although we do our best to protect your personal data, we cannot guarantee the security of your personal information transmitted to our Website. Any transmission of personal information is at your own risk. We are not responsible for circumventing the website\'s privacy settings or security measures.',

    paragraph37:
    'CHANGES TO OUR PRIVACY POLICY',
    paragraph38:
    'Our policy is to post any changes we make to our privacy policy on this page. If we make material changes to how we treat our users\' personal information, we may notify you by e-mail to the e-mail address specified in your account and/or through a notice on the Website home page. The date the privacy policy was last revised is identified at the bottom of this notice. You are responsible for ensuring we have an up-to-date active, and deliverable e-mail address for you and for periodically visiting our website and this privacy policy to check for any changes.',

    paragraph39:
    'CONTACT INFORMATION',

    paragraph40:
    'To ask questions or comment about this Privacy Policy and our privacy practices, contact us at:',

    paragraph41:
    'The Guru Granth Sahib Project',

    paragraph42:
    'https://gurugranthsahib.io ',

    paragraph43:
    //'Updated 2023',
     `Updated ${year}.`,

    paragraph44:
    //'© The Guru Granth Sahib Project 2023. All Rights Reserved.',
      `© The Guru Granth Sahib Project ${year}. All Rights Reserved.`,
  },

  panjabi: {
    title: 'Privacy Policy',
    sggsProject: 'INTRODUCTION',
    subTagLine: '',
    theVision: '',
    paragraph1:
      'The Guru Granth Sahib Project (“TGGSP” or "Company" or "we" or “us”) respects your privacy and is committed to protecting it through its compliance with this policy.',
    paragraph2:
      'This policy describes the types of information we may collect from you or that you may provide when you visit the website',
    link2_1:
    'https://gurugranthsahib.io',  

    paragraph2_1:
    '(the "Website") and our practices for collecting, using, maintaining, protecting, and disclosing that information.',

    paragraph3:
      'This policy applies to the information we collect:',
    paragraph3_1:
    '- On the Website.',
    paragraph3_2:
    '- In e-mail, text, and other electronic messages between you and the Website.',
    
    paragraph4:
    'It does not apply to information collected by:',
    paragraph4_1:
    '- Us offline or through any other means, including on any other website operated by the Company or any third party; or',
    paragraph4_2:
    '- Any third party (including our affiliates and subsidiaries), including through any application or content (including advertising) that may link to or be accessible from the Website',
    
    paragraph5:
    'Please understand our policies and practices regarding your information. If you disagree with our policies and practices, please choose not to use the Website. By accessing or using the Website, you agree to this Privacy Policy. This Policy may change from time to time. Please check the Policy periodically for updates.',

    paragraph6:
    'CHILDREN UNDER THE AGE OF 13',

    paragraph7:
    'The Website is not intended for children under 13 years of age. No one under 13 may provide any information to the Website. We do not knowingly collect personal information from children under 13. If we learn we have collected or received personal information from a child under 13 without verification of parental consent, we will delete that information. If you believe we have any information from or about a child under 13, please contact us at 470 Schooleys Mt Road, Ste 614 Hackettstown, NJ 07840 USA, or at ',
    mail_link:
    'community@sikhri.org',
    paragraph8:
    'INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT',

    paragraph9:
    'We collect several types of information from and about users of the Website, including information:',
    paragraph9_1:
    '- By which you may be personally identified, such as name, postal address, e-mail address, or telephone number ("personal information");',
    paragraph9_2:
    '- That is about you but individually does not identify you; and/or',
    paragraph9_3:
    '- About your internet connection, the equipment you use to access our Website, and usage details.',

    paragraph10:
    'We collect this information:',
    paragraph10_1:
    '- Directly from you when you provide it to us.',
    paragraph10_2:
    '- Automatically as you navigate through the site. Information collected automatically may include usage details, IP addresses, and information collected through cookies.',

    paragraph11:
    'INFORMATION YOU PROVIDE TO US',

    paragraph11_1:
    'The information we collect on or through the Website may include:',
    paragraph11_2:
    '- Information that you provide by filling in forms on our Website. This includes information provided when registering to use the Website, posting material, or requesting further services.',
    paragraph11_3:
    '- You must enter your credit card information when donating by credit card. This information WILL NOT be stored on the TGGSP site. Our payment processing partners, CanadaHelps, PayPal, Stripe, Shopify & eCheck, provide solutions to prevent credit card and banking data from being compromised. All transactions through TGGSP use Transport Layer Security (TLS) to keep information secure and protect against loss or misuse.',
    paragraph11_4:
    '- We may also ask you for information when you report a problem with the Website. If you donated anonymously, your name and e-mail address will not be revealed to other organizations/projects. TGGSP will keep a record of donations but won’t reveal this information.',
    paragraph11_5:
    '- Records and copies of your correspondence (including e-mail addresses) if you contact us.',
    paragraph11_6:
    '- Details of transactions you carry out through the Website and the fulfillment of your orders.',

    paragraph12:
    'You also may provide information to be published or displayed (hereinafter, "posted") on public areas of the Website or transmitted to other users of the Website or third parties (collectively, "User Contributions"). Your User Contributions are posted on and transmitted to others at your own risk. Although you may set certain privacy settings for such information by logging into your account profile, please be aware that no security measures are perfect or impenetrable. Additionally, we cannot control the actions of other website users with whom you may choose to share your User Contributions. Therefore, we cannot and do not guarantee that unauthorized persons will not view your User Contributions.',

    paragraph13:
    'USAGE DETAILS, IP ADDRESSES',
    paragraph13_1:
    'As you navigate through and interact with the Website, we may automatically collect certain information about your equipment, browsing actions, and patterns, including:',
    paragraph13_2:
    '- Details of your visits to the Website, including traffic data, location data, and other communication data and the resources you access and use on the Website.',
    paragraph13_3:
    '- Information about your computer and Internet connection, including your IP address, operating system, and browser type.',

    paragraph14:
    'The information we collect automatically is statistical data and does not identify any individual. It helps us to improve the Website and to deliver a better and more personalized service by enabling us to:',
    paragraph14_1:
    '- Estimate our audience size and usage patterns.',
    paragraph14_2:
    '- Store information about your preferences, allowing us to customize the Website according to your interests.',
    paragraph14_3:
    '- Speed up your searches.',
    paragraph14_4:
    '- Recognize you when you return to the Website.',

    paragraph15:
    'The technologies we use for this automatic data collection may include:',
    paragraph15_1:
    '- Cookies (or browser cookies). A cookie is a small file placed on your computer\'s hard drive. You may refuse to accept browser Cookies by activating the appropriate setting on your browser. However, if you select this setting, you may be unable to access certain parts of our Website. Unless you have adjusted your browser setting to refuse cookies, our system will issue cookies when you direct your browser to our Website.',
    paragraph15_2:
    '- Flash Cookies. Certain website features may use locally stored objects (or Flash cookies) to collect and store information about your preferences and navigation to, from, and on the Website. Flash cookies are not managed by the same browser settings used for browser cookies.',


    paragraph16:
    'THIRD PARTIES AND USE OF COOKIES',
    paragraph17:
    'TGGSP respects your privacy and will never sell, trade, or rent your personal information to outside 3rd parties without consent. Your donation information will be available to the projects and organizations you donate to.',
    paragraph18:
    'Our site uses cookies to keep track of your session ID. We may use cookies to deliver content specific to your interests. We may also track the pages you request, the newsletters you subscribe to, and the advertisements you click on.',
    paragraph19:
    'Third parties may serve some content and/or advertisements on the Website. These third parties may use cookies to collect information about our users. This may include information about user\'s behavior on this and other websites to serve them interested-based (behavioral) advertising. We do not control these third parties tracking technologies or how they may be used. If you have any questions, you should contact the responsible advertiser directly.',

    paragraph20:
    '‍HOW WE USE YOUR INFORMATION',
    paragraph21:
    'We use information that we collect about you or that you provide to us, including any personal information:',
    paragraph21_1:
    '- To present the Website and its contents to you.',
    paragraph21_2:
    '- To provide you with information, products, or services you request from us.',
    paragraph21_3:
    '- To fulfill any other purpose for which you provide it.',
    paragraph21_4:
    '- To carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection.',
    paragraph21_5:
    '- To notify you about changes to the Website or any products or services we offer or provide through it.',
    paragraph21_6:
    '- In any other way, we may describe when you provide the information.',
    paragraph21_7:
    '- For any other purpose with your consent.',
   
    paragraph22:
    'DISCLOSURE OF YOUR INFORMATION',
    paragraph23:
    'We may disclose aggregated information about our users and information that does not identify any individual without restriction.',
    paragraph24:
    'We may disclose personal information we collect or you provide as described in this Privacy Policy:',
    paragraph24_1:
    '- To our subsidiaries and affiliates.',
    paragraph24_2:
    '- To contractors, service providers, and other third parties we use to support our business, and those bound by contractual obligations to keep personal information confidential and use it only for the purposes we disclose it to them.',
    paragraph24_3:
    '- To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of TGGSP\'s assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by TGGSP about the Website users is among the assets transferred.',
    paragraph24_4:
    '- To fulfill the purpose for which you provide it.',
    paragraph24_5:
    '- For any other purpose disclosed by us when you provide the information.',
    paragraph24_6:
    '- With your consent.',
   
    paragraph25:
    'We may also disclose your personal information:',
    paragraph25_1:
    '- To comply with any court order, law, or legal process, including responding to any government or regulatory request.',
    paragraph25_2:
    '- If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of TGGSP, our customers, or others.',
   
    paragraph26:
    'CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION',
    paragraph27:
    'We strive to provide you with choices regarding the personal information you provide us. We have created mechanisms to provide you with the following control over your information:',
    paragraph27_1:
    '- Tracking Technologies and Advertising. You can set your browser to refuse all or some browser cookies or to alert you when cookies are being sent. To learn how to manage your Flash cookie settings, visit Adobe\'s Flash player settings page. If you disable or refuse cookies, please note that some parts of this site may be inaccessible or malfunctioning.',
    paragraph28:
    'We do not control third parties collection or use of your information to serve interest-based advertising. However, these third parties may provide ways to refrain from having your information collected or used this way. You can opt out of receiving targeted ads from members of the Network Advertising Initiative ("NAI") on the NAI\'s Website.',
    
    paragraph29:
    'ACCESSING AND CORRECTING YOUR INFORMATION',
    paragraph30:
    'You may also send us an e-mail at', 

    paragraph30_1: 
    'to request access to, correct, or delete any personal information you provided. We cannot delete your personal information. We may not accommodate a request to change information if we believe the change would violate any law or legal requirement or cause the information to be incorrect.',
    paragraph31:
    'Suppose you delete your User Contributions from the Website. In that case, copies of your User Contributions may remain viewable in cached and archived pages or have been copied or stored by other Website users.',
    paragraph32:
    'YOUR CALIFORNIA PRIVACY RIGHTS',
    paragraph33:
    'California Civil Code Section § 1798.83 permits users of our Website that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an e-mail to', 
    paragraphAt: 'or write us at:',
    paragraph33_1: 
    '470 Schooleys Mt Road, Ste 614',
    paragraph33_2:
    'Hackettstown, NJ 07840 USA',

    paragraph34:
    'DATA SECURITY',

    paragraph35:
    'We have implemented measures to secure your personal information from accidental loss and unauthorized access, use, alteration, and disclosure. All information you provide is stored on our secure servers behind firewalls. Any payment transactions will be encrypted.The safety and security of your information also depends on you. ',
    
    paragraph36:
    'Although we do our best to protect your personal data, we cannot guarantee the security of your personal information transmitted to our Website. Any transmission of personal information is at your own risk. We are not responsible for circumventing the website\'s privacy settings or security measures.',

    paragraph37:
    'CHANGES TO OUR PRIVACY POLICY',
    paragraph38:
    'Our policy is to post any changes we make to our privacy policy on this page. If we make material changes to how we treat our users\' personal information, we may notify you by e-mail to the e-mail address specified in your account and/or through a notice on the Website home page. The date the privacy policy was last revised is identified at the bottom of this notice. You are responsible for ensuring we have an up-to-date active, and deliverable e-mail address for you and for periodically visiting our website and this privacy policy to check for any changes.',

    paragraph39:
    'CONTACT INFORMATION',

    paragraph40:
    'To ask questions or comment about this Privacy Policy and our privacy practices, contact us at:',

    paragraph41:
    'The Guru Granth Sahib Project',

    paragraph42:
    'https://gurugranthsahib.io ',

    paragraph43:
    //'Updated 2023',
     `Updated ${year}.`,

    paragraph44:
    //'© The Guru Granth Sahib Project 2023. All Rights Reserved.',
      `© The Guru Granth Sahib Project ${year}. All Rights Reserved.`,
  },
};
